<template>
    <div>
      <router-link :to="{path:'/enterquerylist'}"  class="sidebar-nav-link" >
  <span><el-button  style="margin-left: 40%" type="primary" @click="autSearch" size="medium">评价申请结果查询</el-button></span>
      </router-link>
</div>
</template>

<script>
export default {
  name: 'enterquerylists'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterquerylists.vue